/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-ts-comment */

import { AxiosError } from "axios";

import api from "services/api";
import { returnResponse } from "services/utils";

import { LogOperation } from "utils/entities/logOperation";

export const AttendantRoleService = {
  getAttendantRoleByHearingType: async (hearingTypeId: number) => {
    try {
      const { data } = await api.get<any>(
        `/v1/AttendantRole/GetAllByHearingTypeId?hearingTypeId=${hearingTypeId}`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      console.error("Erro ao buscar os tipos de participante:", error);
      throw error;
    }
  },

  getAllCustomerId: async (customerId: number, status?: 0 | 1 | null) => {
    try {
      const { data } = await api.get<any>(
        `/v1/UserCustomer/GetAll?customerId=${customerId}${
          status !== null ? `&active=${status}` : ""
        }`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (err) {
      return {
        status: false,
        data: null,
        message: "Houve um erro ao consultar os registros.",
      };
    }
  },
  getAllByUser: async (userId: number) => {
    try {
      const { data } = await api.get<any>(
        `/v1/UserCustomerProfile/GetUserCustomerProfilesByUserId?UserId=${userId}`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
  getAllPlace: async (customerId: number, status?: 0 | 1 | null) => {
    try {
      const { data } = await api.get<any>(
        `/v1/UserCustomerProfile/GetAllByCustomerIdWithMaster?customerId=${customerId}${
          status === 0 || status === 1 ? `&active=${status}` : ""
        }`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  getAllByCustomerId2: async (
    customerId: number,
    userId?: number,
    type?: number,
  ) => {
    const userIdSelected = userId ? `&userId=${userId}` : "";
    const typeSelected = type ? `&type=${type}` : "";
    try {
      if (customerId) {
        const { data } = await api.get(
          `/v1/Place/GetAllToBindByUserIdAndTypeDTO?customerId=${customerId}${userIdSelected}${typeSelected}`,
        );

        return {
          status: true,
          body: data.data,
        };
      } else {
        throw new Error("user not set on local storage");
      }
    } catch (error: any) {
      return {
        status: true,
        body: error.response,
      };
    }
  },
  getById: async (id: number) => {
    try {
      const { data } = await api.get<any>(`/v1/AttendantRole/Get?id=${id}`);

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  getAllByCustomer: async (id: number) => {
    try {
      const { data } = await api.get<any>(
        `v1/Place/GetAllByCustomerIdUserId?customerId=1&userId=${id}`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
  //@ts-ignore
  post: async (authToken: string | null, attendantRole: any) => {
    try {
      const body = {
        ...attendantRole,
        device: LogOperation.getDevice(),
        ip: LogOperation.getMachineIP(),
        logPoliceUnitId: LogOperation.getPoliceUnitId(),
        logUserId: LogOperation.getUserId(),
      };
      const { data } = await api.post<any>(`/v1/AttendantRole/Add`, body);

      return {
        status: true,
        data: data.data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  //@ts-ignore
  put: async (authToken: string | null, attendantRole: any) => {
    try {
      const body = {
        ...attendantRole,
        device: LogOperation.getDevice(),
        ip: LogOperation.getMachineIP(),
        logPoliceUnitId: LogOperation.getPoliceUnitId(),
        logUserId: LogOperation.getUserId(),
      };
      const { data } = await api.put<any>(`/v1/AttendantRole/Update`, body);

      return {
        status: true,
        data: data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }
      let severity: "error" | "warning" | "success";
      severity = "error";
      return {
        status: false,
        message: "Error",
        data: null,
        severity: severity,
      };
    }
  },

  //@ts-ignore
  delete: async (authToken: string | null, attendantRoleId: number) => {
    try {
      const body = [
        {
          op: "replace",
          value: false,
          path: "active",
        },
      ];

      const { data } = await api.patch(
        `/v1/AttendantRole/update?id=${attendantRoleId}`,
        body,
      );

      return {
        status: true,
        data: data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
};
